import React from 'react'

import styles from './GetStarted.module.scss'
import images from 'assets/images'
import Button from 'components/Button'
import { ArrowDownToLineIcon } from 'lucide-react'

const arrInfo = [
  {
    icon: 'icon-ic-wallet',
    name: 'Store VIC',
    value: 'store',
  },
  {
    icon: 'icon-ic-layout',
    name: 'Transfer VIC',
    value: 'transfer',
  },
  {
    icon: 'icon-ic-vic',
    name: 'Use VIC',
    value: 'use',
  },
  {
    icon: 'icon-ic-drop',
    name: 'Retrodrop',
    value: 'retrodrop',
  },
]

const arrSteps = [
  {
    step: 'STEP 1:',
    title: 'Download Coin98 Super Wallet',
    description: 'Recommended – flagship wallet on Viction',
    icon: images.walletImg,
  },
  {
    step: 'STEP 2:',
    title: 'Create your account',
    icon: images.userImg,
    isRight: true,
  },
  {
    step: 'STEP 3:',
    title: "Back up your recovery or 'seed' phrase.",
    icon: images.noteImg,
  },
]

const arrTransfer = [
  {
    title: 'Transfer asset to VIC',
    description:
      'You can use bridge to transfer assets from Ethereum, Arbitrum One, BNB Smart Chain, Solana, etc. to Viction',
    linkText: 'View all bridges on Viction',
    value: 'transfer',
    img: images.transfer1,
    link: '/bridge',
  },
  {
    title: 'Use VIC',
    description: 'Discover the way you can pay, play, own VIC',
    linkText: 'Explore VIC Utility',
    value: 'use',
    img: images.transfer2,
    link: '/utility',
  },
  {
    title: 'Explore Retrodrop',
    description: `From the very beginning, you have been more than a participant; you've been a co-creator in the Viction story`,
    linkText: 'View All Retrodrop Seasons on Viction',
    value: 'retrodrop',
    img: images.transfer3,
    link: 'https://retrodrop.viction.xyz/',
    isBlank: true,
  },
]

function GetStartedScreen() {
  const onChooseItem = (value) => () => {
    const positionTransferWrapper = document.querySelector(
      '.get-started-transfer'
    )
    const positionTransferWrapperTemp =
      positionTransferWrapper && positionTransferWrapper?.offsetTop
    const positionTransfer = document.querySelector('#transfer')
    const positionUse = document.querySelector('#use')
    const positionRetrodrop = document.querySelector('#retrodrop')
    const positionStore = document.querySelector('#store')

    if (value === 'store' && positionStore) {
      window.scrollTo({
        top: positionStore?.offsetTop - 100,
        behavior: 'smooth',
      })
    }

    if (value === 'transfer' && positionTransfer) {
      window.scrollTo({
        top: positionTransferWrapperTemp + positionTransfer?.offsetTop - 100,
        behavior: 'smooth',
      })
    }

    if (value === 'use' && positionUse) {
      window.scrollTo({
        top: positionTransferWrapperTemp + positionUse?.offsetTop - 100,
        behavior: 'smooth',
      })
    }

    if (value === 'retrodrop' && positionRetrodrop) {
      window.scrollTo({
        top: positionTransferWrapperTemp + positionRetrodrop?.offsetTop - 100,
        behavior: 'smooth',
      })
    }
  }

  return (
    <div className={styles.getStartedScreen}>
      <div className='get-started-container'>
        <div className='get-started-banner'>
          <div className='banner-top'>
            <div className='banner-top__img'>
              <img
                src={images.bgBannerGetStarted}
                alt=''
                className='banner-bg'
              />
            </div>

            <div className='banner-info'>
              <img src={images.creamCurve} alt='' className='cream-curve' />

              <h1 className='banner-info-title'>
                Own your <span>$VIC</span>
              </h1>

              <div className='banner-info-content'>
                {arrInfo.map((item, index) => {
                  return (
                    <div
                      className='info-content-item'
                      key={index}
                      onClick={onChooseItem(item.value)}>
                      <div className='content-icon'>
                        <span className={item.icon}></span>
                        <span className='icon-web_arrow_up_right arrow-icon'></span>
                      </div>

                      <div className='content-name'>{item.name}</div>
                    </div>
                  )
                })}
              </div>
            </div>
          </div>

          <div className='banner-content-wrapper' id='store'>
            <div className='banner-content-container'>
              <div className='banner-content'>
                <div className='banner-content-title'>
                  Set up your wallet on Viction
                </div>

                <div className='banner-content-detail'>
                  {arrSteps.map((item, index) => {
                    const firstItem = index === 0

                    return (
                      <div
                        className={`content-detail-item ${
                          item.isRight && 'content-detail-item--right'
                        }`}
                        key={index}>
                        <div className='item-img'>
                          <img src={item.icon} alt='' className='img-item' />
                        </div>

                        <div className='item-info'>
                          <div className='item-info__step'>{item.step}</div>

                          <div className='item-info__detail'>
                            <div className='detail-title'>{item.title}</div>

                            {item.description && (
                              <div className='detail-description'>
                                {item.description}
                              </div>
                            )}

                            {firstItem && (
                              <>
                                <a href='https://coin98.com'>
                                  <Button variant='secondary'>
                                    <ArrowDownToLineIcon className='icon-download' />
                                    Download Wallet
                                  </Button>
                                </a>

                                <div className='detail-link text-hover-underline'>
                                  <a href='/gateway'>
                                    View all other wallets supporting VIC here
                                  </a>
                                </div>
                              </>
                            )}
                          </div>
                        </div>
                      </div>
                    )
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className='get-started-transfer'>
          <img
            src={images.curveBlackBottom}
            alt=''
            className='curve-black-bottom'
          />

          <div className='transfer-wrapper'>
            <div className='transfer-container'>
              {arrTransfer.map((item, index) => {
                return (
                  <div className='transfer-item' id={item.value} key={index}>
                    <div className='transfer-item__info'>
                      <div className='transfer-info-title'>{item.title}</div>

                      <div className='transfer-info-description'>
                        {item.description}
                      </div>

                      <div className='transfer-info-link text-hover-underline-white'>
                        <a
                          href={item.link}
                          target={item.isBlank ? '_blank' : '_self'}
                          rel='noopener noreferrer'>
                          {item.linkText}
                        </a>
                      </div>
                    </div>

                    <div className='transfer-item__img'>
                      <img src={item.img} alt='' className='img-transfer' />
                    </div>
                  </div>
                )
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default GetStartedScreen
